import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

function AssignedStaffRow({ teamId, contactId, csrfToken, staffOptions, assignedStaffId, assignedStaff, canEdit, onSaved }) {
  const selected = staffOptions.find((staff) => staff.id === assignedStaffId);
  const departed = assignedStaffId && !selected && assignedStaff?.id === assignedStaffId ? assignedStaff : null;

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleChange = async (e) => {
    const value = e.target.value ? Number(e.target.value) : null;
    setSaving(true);
    setError('');
    try {
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
      const response = await axios.patch(`/teams/${teamId}/crm/fans/${contactId}.json`, {
        fan: { assigned_staff_id: value },
      });
      onSaved(response.data);
    } catch (err) {
      setError('Could not save relationship manager');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="cdp-side-row">
        <span className="cdp-side-row-label">Relationship Manager</span>
        <span className="cdp-side-row-value">
          {!canEdit && (selected?.name || departed?.name || 'Unassigned')}
          {canEdit && (
            <select
              className="form-control form-control-sm w-auto"
              aria-label="Relationship manager"
              value={assignedStaffId || ''}
              disabled={saving}
              onChange={handleChange}
            >
              <option value="">Unassigned</option>
              {departed && <option value={departed.id}>{`${departed.name} (can't be assigned)`}</option>}
              {staffOptions.map((staff) => (
                <option key={staff.id} value={staff.id}>{staff.name}</option>
              ))}
            </select>
          )}
        </span>
      </div>
      {selected && !selected.phone && <div className="text-muted small mb-1">No confirmed phone — texts can't reach them</div>}
      {error && <div className="text-danger small mb-1">{error}</div>}
    </>
  );
}

AssignedStaffRow.propTypes = {
  teamId: PropTypes.number.isRequired,
  contactId: PropTypes.number.isRequired,
  csrfToken: PropTypes.string.isRequired,
  staffOptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    phone: PropTypes.bool,
  })),
  assignedStaffId: PropTypes.number,
  assignedStaff: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  canEdit: PropTypes.bool,
  onSaved: PropTypes.func.isRequired,
};

AssignedStaffRow.defaultProps = {
  staffOptions: [],
  assignedStaffId: null,
  assignedStaff: null,
  canEdit: true,
};

export default AssignedStaffRow;
